export default __webpack_public_path__ + "static/media/Ubicacion.cc757538.png";